export const SITE = {
  name: "Terra Bloom DWC LLC",
  brand: "TERRA BLOOM",
  brandSub: "DWC LLC",
  tagline: "Premium Petroleum Solutions for Critical Industries",
  email: "info@tbdwc.com",
  phone: "+971 56 263 6864",
  phoneHref: "tel:+971562636864",
  whatsapp: "+971 56 263 6864",
  whatsappLink:
    "https://wa.me/971562636864?text=" +
    encodeURIComponent("Hello Terra Bloom, I'd like to discuss a petroleum product inquiry."),
  address: "Office 3, Building A3, 3rd Floor, DWC Business Center, Dubai Aviation City, PO Box 390667, Dubai, UAE",
  mapEmbed:
    "https://www.openstreetmap.org/export/embed.html?bbox=55.08%2C24.82%2C55.24%2C24.92&layer=mapnik&marker=24.87%2C55.16",
  domain: "https://tbdwc.com",
  brochure: "/terra-bloom-brochure.pdf",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1513295202663-54cd69dd2b43?w=1920&q=80&auto=format&fit=crop",
  sunset:
    "https://images.unsplash.com/photo-1786532850237-b4ce3231fd10?w=1600&q=80&auto=format&fit=crop",
  towers:
    "https://images.unsplash.com/photo-1646124839366-67161db62d80?w=1600&q=80&auto=format&fit=crop",
  tanker:
    "https://images.unsplash.com/photo-1568347877321-f8935c7dc5a3?w=1600&q=80&auto=format&fit=crop",
  vessel:
    "https://images.unsplash.com/photo-1604506522146-316c8bedd874?w=1600&q=80&auto=format&fit=crop",
  night:
    "https://images.unsplash.com/photo-1584060330377-3fd93ef4e991?w=1600&q=80&auto=format&fit=crop",
  steelPlant: "https://images.unsplash.com/photo-1474674556023-efef886fa147?w=1600&q=80&auto=format&fit=crop",
  steelRebar: "https://images.unsplash.com/photo-1763771420551-18bc44399f0c?w=1600&q=80&auto=format&fit=crop",
  steelCoils: "https://images.unsplash.com/photo-1697698532634-ea59b636ccea?w=1600&q=80&auto=format&fit=crop",
  steelBeams: "https://images.unsplash.com/photo-1627922529156-41f27fb6f7ac?w=1600&q=80&auto=format&fit=crop",
};

export const STATS = [
  { value: 9, suffix: "", label: "Specialist product lines", decimals: 0 },
  { value: 24, suffix: "h", label: "Inquiry response pledge", decimals: 0 },
  { value: 100, suffix: "%", label: "Batches shipped with CoA", decimals: 0 },
  { value: 4, suffix: "", label: "Trade terms — FOB CFR CIF DAP", decimals: 0 },
];

export const COUNTRIES = [
  ["United Arab Emirates", "+971"],
  ["Saudi Arabia", "+966"],
  ["Qatar", "+974"],
  ["Oman", "+968"],
  ["Kuwait", "+965"],
  ["Bahrain", "+973"],
  ["Jordan", "+962"],
  ["Iraq", "+964"],
  ["Iran", "+98"],
  ["Egypt", "+20"],
  ["Turkey", "+90"],
  ["India", "+91"],
  ["Pakistan", "+92"],
  ["Bangladesh", "+880"],
  ["China", "+86"],
  ["Hong Kong", "+852"],
  ["Taiwan", "+886"],
  ["Japan", "+81"],
  ["South Korea", "+82"],
  ["Singapore", "+65"],
  ["Malaysia", "+60"],
  ["Indonesia", "+62"],
  ["Vietnam", "+84"],
  ["Thailand", "+66"],
  ["Philippines", "+63"],
  ["Australia", "+61"],
  ["United Kingdom", "+44"],
  ["Germany", "+49"],
  ["France", "+33"],
  ["Italy", "+39"],
  ["Spain", "+34"],
  ["Netherlands", "+31"],
  ["Belgium", "+32"],
  ["Switzerland", "+41"],
  ["Poland", "+48"],
  ["Greece", "+30"],
  ["Portugal", "+351"],
  ["Romania", "+40"],
  ["Ukraine", "+380"],
  ["Russia", "+7"],
  ["United States", "+1"],
  ["Canada", "+1"],
  ["Mexico", "+52"],
  ["Brazil", "+55"],
  ["Argentina", "+54"],
  ["Chile", "+56"],
  ["Colombia", "+57"],
  ["Nigeria", "+234"],
  ["Ghana", "+233"],
  ["Kenya", "+254"],
  ["Ethiopia", "+251"],
  ["Tanzania", "+255"],
  ["South Africa", "+27"],
  ["Morocco", "+212"],
  ["Algeria", "+213"],
  ["Israel", "+972"],
  ["Lebanon", "+961"],
];
